import { render, staticRenderFns } from "./PortalNavMenu.vue?vue&type=template&id=4edd1fd4"
import script from "./PortalNavMenu.vue?vue&type=script&lang=js"
export * from "./PortalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./PortalNavMenu.vue?vue&type=style&index=0&id=4edd1fd4&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3413842915/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4edd1fd4')) {
      api.createRecord('4edd1fd4', component.options)
    } else {
      api.reload('4edd1fd4', component.options)
    }
    module.hot.accept("./PortalNavMenu.vue?vue&type=template&id=4edd1fd4", function () {
      api.rerender('4edd1fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PortalNavMenu.vue"
export default component.exports